module.exports = __webpack_public_path__ + "img/PS34.f5251cc2.png";